<template>
  <div id="app">
    <!-- World Headbar versione SPA -->
    <world-headbar
      @openWorldMenu="worldMenuOpen = !worldMenuOpen"
      :hintFn="searchFn"
      :customHintRows="customHintRows"
    />
    <vue-progress-bar></vue-progress-bar>
    <!-- Menu laterale di navigazione -->
    <world-menu
      v-if="!checkingLogin"
      :menu-open="worldMenuOpen"
      @closeWorldMenu="worldMenuOpen = false"
    />
    <!-- Link refresh app -->
    <div class="pwa-refresh-app-banner" v-if="showRefreshPopup">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-l">
          {{
            $anm22.strLang(
              lang,
              "A new version of app is available. Refresh the page.",
              "Una nuova versione dell'app è disponibile. Ricarica la pagina."
            )
          }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <button
            type="button"
            class="com-anm22-button small light-blue"
            @click="pageReload"
          >
            <img :src="$anm22.icons.getWorldIcon('refreshWhite')" />
            <div>{{ $anm22.strLang(lang, "Refresh", "Ricarica") }}</div>
          </button>
        </div>
      </div>
    </div>
    <!-- Router View, contenitore per il rendering dei componenti in fase di navigazione -->
    <div
      class="com-anm22-app-outer-wrapper"
      @click="
        'void(0);';

      "
      :style="$route.path === '/login' ? 'padding-left:0;' : ''"
    >
      <div v-if="checkingLogin" class="wg-row" style="justify-content:center;">
        <div class="vertical-height-div" style="height:40px;"></div>
        <div class="com-anm22-app-text-xxl">
          {{ $anm22.strLang(lang, "Logging in...", "Accesso in corso...") }}
        </div>
      </div>
      <router-view v-else></router-view>
    </div>
    <footer
      v-if="!userLogged"
      style="position:fixed; left:0; bottom:0; border-top: 1px #efefef solid; background-color:#FFF; z-index:1000; width:100%;"
    >
      <div style="font-size:14px; color:#999; padding:5px 20px;">
        ANM22 World -
        <a href="https://www.anm22.it/it/privacy-policy/" style="color:#666;"
          >Privacy Policy</a
        >
        -
        <a href="https://www.anm22.it/it/cookies/" style="color:#666;"
          >Cookie Policy</a
        >
      </div>
    </footer>
    <portal-target name="anm22-portal-modal" multiple>
      <!--
      Destinazione per il render dei modali
      -->
    </portal-target>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import WorldHeadbar from "../../../world/spa/components/WorldHeadbar.vue";
import WorldMenu from "../../../world/spa/components/WorldMenu.vue";
import { PortalTarget } from "portal-vue";

export default {
  data() {
    return {
      worldMenuOpen: false,
      showRefreshPopup: false,
      loadedPlugins: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      workSelected: (state) => state.workSelected,
      userLogged: (state) => state.auth.userLogged,
      checkingLogin: (state) => state.auth.checkingLogin,
    }),
    userPermission() {
      if (this.userLogged) {
        return this.$store.getters["employments/getPermByWork"](
          this.workSelected
        );
      }
    },
    licenses() {
      return this.$store.getters["licenses/getAll"];
    },
    employments() {
      if (this.userLogged) {
        return this.$store.getters["employments/getByUser"](
          this.user.idWorldUser
        );
      } else {
        return [];
      }
    },
    // licenses
    tasksMenu() {
      let menu = [
        {
          items: [
            {
              name: "tasks",
              external: false,
              icon: this.$anm22.icons.getWorldIcon("menuTasks"),
              iconHover: this.$anm22.icons.getWorldIcon("menuTasksGreen"),
              description: "Tasks",
              href: "/",
              selectId: "tasks",
            },
            {
              name: "calendar",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuCalendar"),
              iconHover: this.$anm22.icons.getWorldIcon("menuCalendarRed"),
              description: "Calendar",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://calendar.anm22.it"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/calendar-v/",
              selectId: "calendar",
            },
            {
              name: "contacts",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuContacts"),
              iconHover: this.$anm22.icons.getWorldIcon("menuContactsBlue"),
              description: "Contacts",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://contacts.anm22.it"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/contacts-v/",
              selectId: "contacts",
            },
            {
              name: "pay",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuWallet"),
              iconHover: this.$anm22.icons.getWorldIcon("menuWalletBrown"),
              description: "Pay",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://www.anm22.it/app/pay/"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/pay/",
              selectId: "pay",
            },
            {
              name: "inbox",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("inbox"),
              description: "Inbox",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://inbox.anm22.it"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/inbox-v/",
              selectId: "inbox",
            },
            {
              name: "resource",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuResource"),
              iconHover: this.$anm22.icons.getWorldIcon("menuResourceYellow"),
              description: "Resource",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://resource.anm22.it"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/resource-v/",
              selectId: "resource",
            },
          ],
        },
        {
          items: [
            {
              name: "settings",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuSettings"),
              description: this.$anm22.strLang(
                this.lang,
                "Settings",
                "Impostazioni"
              ),
              href:
                process.env.NODE_ENV === "production"
                  ? "https://www.anm22.it/app/work/settings"
                  : process.env.VUE_APP_FRONT_DOMAIN + "/app/work/settings",
              selectId: "settings",
            },
            {
              name: "switch",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuSwitch"),
              description: this.$anm22.strLang(
                this.lang,
                "Change company",
                "Cambia azienda"
              ),
              selectId: "switch",
              href:
                process.env.NODE_ENV === "production"
                  ? "https://www.anm22.it/app/work/selectWork?cbSucc=" +
                    encodeURIComponent("https://tasks.anm22.it")
                  : process.env.VUE_APP_FRONT_DOMAIN +
                    "/app/work/selectWork?cbSucc=" +
                    encodeURIComponent("../tasks-v/"),
            },
            {
              name: "help",
              external: true,
              icon: this.$anm22.icons.getWorldIcon("menuHelp"),
              description: this.$anm22.strLang(this.lang, "Help", "Aiuto"),
              href: "https://www.anm22.it/it/tasks-tutorial/",
              selectId: "help",
            },
          ],
        },
      ];
      if (this.workSelected == 474 && this.userPermission <= 3) {
        menu[0].items.push({
          name: "administration",
          external: true,
          icon: this.$anm22.icons.getWorldIcon("menuAdmin"),
          description: this.$anm22.strLang(
            this.lang,
            "Administration",
            "Amministrazione"
          ),
          href:
            process.env.NODE_ENV === "production"
              ? "https://www.anm22.it/app/work/link-administration"
              : process.env.VUE_APP_FRONT_DOMAIN +
                "/app/work/link-administration",
          selectId: "administration",
        });
      }
      if (
        this.workSelected == 1 ||
        this.workSelected == 2 ||
        this.workSelected == 16 ||
        this.workSelected == 965
      ) {
        menu[0].items.push({
          name: "warehouse",
          external: false,
          icon: this.$anm22.icons.getWorldIcon("menuWarehouse"),
          iconHover: this.$anm22.icons.getWorldIcon("menuWarehouseYellow"),
          description: this.$anm22.strLang(this.lang, "Warehouse", "Magazzino"),
          href: "/warehouse",
          selectId: "warehouse",
        });
      }
      return menu;
    },
    customHintRows() {
      if (this.userLogged) {
        return this.employments
          .filter((e) => {
            const license = this.$store.getters["licenses/getByWork"](e.work);
            return (
              license &&
              license.config.tasks &&
              license.config.tasks.search &&
              license.config.tasks.search["advanced-search-url"] !== ""
            );
          })
          .map((e) => {
            const work = this.$store.getters["works/get"](e.work);
            const license = this.$store.getters["licenses/getByWork"](e.work);
            // URL ricerca avanzata (prima bisogna verificare l'esistenza della configurazione)
            if (
              license &&
              license.config.tasks &&
              license.config.tasks.search
            ) {
              const url = license.config.tasks.search["advanced-search-url"];
            } else {
              const url = "";
            }
            return {
              label:
                this.$anm22.strLang(
                  this.lang,
                  "Advanced search - ",
                  "Ricerca avanzata - "
                ) + work.name,
              url: url,
            };
          });
      } else {
        return [];
      }
    },
  },
  methods: {
    pageReload() {
      location.reload();
    },
    searchFn(string) {
      const regexp = new RegExp(string, "i");
      let results = [];
      /* Ricerca contatti per nome */
      this.$store.getters["projects/getAll"]
        .filter((p) => {
          return (
            -1 !== p.name.search(regexp) || -1 !== p.projectId.search(regexp)
          );
        })
        .map((p) => {
          const label =
            (p.projectId || "") +
            (p.projectId && p.name ? " - " : "") +
            (p.name || "");
          return {
            label: label,
            img: this.$anm22.icons.getWorldIcon("tag"),
            submitFn: () => {
              this.$router.push("/project/" + p.idWorldProject);
            },
          };
        })
        .forEach((p) => {
          results.push(p);
        });
      return results;
    },
  },
  components: {
    WorldHeadbar,
    WorldMenu,
    PortalTarget,
  },
  created() {
    this.$store.dispatch("offline/loadSyncTuples", this.$vlf("syncUpdates"));
    this.$store.dispatch("headbar/enableSearchbar");
    // Cookie-selected work
    let w = this.$anm22.getCookie("anm22_work");
    if (w !== "") {
      this.$store.dispatch("setWorkSelected", w === "my" ? w : Number(w));
    }
    this.$store.dispatch("menu/setCategories", this.tasksMenu);
    // Cattura l'evento lanciato dal service worker
    window.addEventListener("content-updated", () => {
      this.showRefreshPopup = true;
    });
    // Service worker offline sync event
    // if('serviceWorker' in navigator){
    //   // Handler for messages coming from the service worker
    //   navigator.serviceWorker.addEventListener('message', event => {
    //     if(event.data.type === 'sync-data') {
    //       // console.log(event.data);
    //       event.data.objs.forEach(d => {
    //         if(d.old.type === 'new' || d.old.type === 'edit'){
    //           this.$store.dispatch(d.table + '/update', {
    //             vlf: this.$vlf(d.table), objs: [d.obj]
    //           });
    //           if(d.old.type === 'new') {
    //             this.$store.dispatch(d.table + '/delete', {
    //               vlf: this.$vlf(d.table), obj: d.old.obj
    //             });
    //           }
    //         }
    //       });
    //     }
    //   });
    // }
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
  },
  mounted() {
    this.$store.dispatch("updateDimensions", {
      width: window.innerWidth,
      height: window.innerHeight,
    });
    this.$nextTick(() => {
      window.addEventListener(
        "resize",
        _.debounce(() => {
          this.$store.dispatch("updateDimensions", {
            width: window.innerWidth,
            height: window.innerHeight,
          });
        }, 500)
      );
    });
  },
  watch: {
    licenses(newVal, old) {
      // Carico librerie di configurazione specifiche per le licenze di Tasks in uso
      newVal.forEach((l) => {
        if (
          l &&
          l.config.tasks &&
          l.config.tasks.plugin &&
          !this.loadedPlugins.includes(l.config.tasks.plugin)
        ) {
          import("../libs/custom/" + l.config.tasks.plugin + ".js").then(
            (lib) => {
              Object.assign(this.$anm22, lib.default);
              this.loadedPlugins.push(l.config.tasks.plugin);
              // Init plugin
              this.$anm22[l.config.tasks.plugin + "_init"](this);
            }
          );
        }
      });
    },
    workSelected(newVal, old) {
      this.$store.dispatch("menu/setCategories", this.tasksMenu);
    },
    userPermission(newVal, old) {
      this.$store.dispatch("menu/setCategories", this.tasksMenu);
    },
  },
};
</script>

<style lang="css">
/* #app {
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
} */
</style>
